var exports = {
  "x": "ClientInfo.module__button___UmhZLW",
};

module.exports = exports;
